// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1JobSchema = z.object({
  id: z.number().int(),
  status: z.enum(["created", "in_progress", "finished", "failed", "cancelled"]),
  details: z.object({}),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
  finished_at: z.string().datetime().nullish(),
});
